module.exports = __webpack_public_path__ + "static/media/Template_3.56cd4222.png";